import { render, staticRenderFns } from "./freeMarketList.vue?vue&type=template&id=13d9e83c&"
import script from "./freeMarketList.vue?vue&type=script&lang=js&"
export * from "./freeMarketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports